import { type PropsWithChildren, useEffect, useRef } from "react";
import { Box } from "@mui/material";

/** Keeps global notices above navigation, including when their wrapped text changes height. */
export function NoticeHeader({ children }: PropsWithChildren) {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const node = ref.current;
		if (!node) return;
		const update = () =>
			document.documentElement.style.setProperty(
				"--tandem-notice-height",
				node.getBoundingClientRect().height + "px"
			);
		const observer = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(update);
		observer?.observe(node);
		update();
		return () => {
			observer?.disconnect();
			document.documentElement.style.removeProperty("--tandem-notice-height");
		};
	}, []);
	return (
		<Box
			ref={ref}
			sx={{ position: "sticky", top: 0, zIndex: (theme) => theme.zIndex.appBar + 1 }}
		>
			{children}
		</Box>
	);
}
